import { query } from "./calls";

export const WebSession = {
    get: (token) => query(`SELECT * FROM (SELECT sessions FROM WebSession).sessions as sessions WHERE token = '${token}'`)
}